import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск детали при кроссировании.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'parts'];
  }

  initialize() {
    this.timeout = null;
    this.brandField = this.element.querySelector('[name="brand_id"]');
    this.articleField = this.element.querySelector('[name="article"]');
    this.partIdField = this.element.querySelector('[name="part_id"]');
  }

  connect() {
    const that = this;
    document.body.addEventListener('click', () => { that.partsTarget.style.display = 'none'; });

    this.inputTarget.addEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.addEventListener('paste', () => setTimeout(this.searchShipmentParts(), 250));
  }

  disconnect() {
    this.inputTarget.removeEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.removeEventListener('paste', () => this.searchShipmentParts());
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<div class="dropdown-item">Деталь «${article}» не найдена.</div>`;
    this.partsTarget.style.display = null;
  }

  renderPart(part) {
    var link = `<a class="dropdown-item" data-action="click->office--part--search-parts-for-cross#selectPart" data-part-id="${part.id}"
    data-article="${part.article}" data-name="${part.shortName}" data-brand-id="${part.brandId}" data-crosses="${part.crosses}" style="z-index: 5; white-space: normal !important;">
       ${part.shortName}`;
    if (part.crosses) {
      link = link + `<br>
        <span class="is-size-7 has-text-grey" data-action="click->office--part--search-parts-for-cross#selectPart" data-part-id="${part.id}"
        data-article="${part.article}" data-name="${part.shortName}" data-brand-id="${part.brandId}" data-crosses="${part.crosses}">
          Вместе с выбранной деталью будут добавлены следующие детали из кросса: ${part.crosses}
        </span>
      `
    }
    link = link + '</a>';
    return link;
  }

  renderParts(parts) {
    const result = [];
    for (const part of parts) {
      result.push(this.renderPart(part));
    }
    this.partsTarget.innerHTML = result.join('');
    this.partsTarget.style.display = null;
  }

  searchShipmentParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value.replace(/\s/g, '');
      if (article.length > 2) {
        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/office/parts/simple_search?q=${article}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 500);
  }

  selectPart(event) {
    this.brandField.value = event.target.dataset.brandId;

    this.articleField.value = event.target.dataset.article;

    this.partIdField.value = event.target.dataset.partId;

    if (event.target.dataset.crosses == 'null') {
      document.getElementById('merge_crosses_btn').dataset.confirm = "Вы уверены, что хотите кроссировать " + event.target.dataset.name + "?";
    } else {
      document.getElementById('merge_crosses_btn').dataset.confirm = "Вы уверены, что хотите кроссировать " + event.target.dataset.name + " и весь её кросс: " + event.target.dataset.crosses + "?";
    }

    this.partsTarget.style.display = 'none';
  }
}
